import { render } from "./ClaimComplementRequestReview.vue?vue&type=template&id=c16ddcc6"
import script from "./ClaimComplementRequestReview.vue?vue&type=script&lang=js"
export * from "./ClaimComplementRequestReview.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ClaimComplementRequestReview.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_2b42b3c8%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Fcomplement-request%2FClaimComplementRequestReview.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__